import { render, staticRenderFns } from "./Restore.vue?vue&type=template&id=5d366e20&scoped=true&"
import script from "./Restore.vue?vue&type=script&lang=js&"
export * from "./Restore.vue?vue&type=script&lang=js&"
import style0 from "./Restore.vue?vue&type=style&index=0&id=5d366e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d366e20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d366e20')) {
      api.createRecord('5d366e20', component.options)
    } else {
      api.reload('5d366e20', component.options)
    }
    module.hot.accept("./Restore.vue?vue&type=template&id=5d366e20&scoped=true&", function () {
      api.rerender('5d366e20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/Restore.vue"
export default component.exports